import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const tasksImporterSelectors = importerSelectors(
  'tasks.importer',
)

export default tasksImporterSelectors
